import { createAsyncActionTypes } from 'conversations-async-data/async-action/createAsyncActionTypes';
export const FETCH_AGENTS = createAsyncActionTypes('FETCH_AGENTS');
export const SIDEBAR_OPT_STATUS = createAsyncActionTypes('SIDEBAR_OPT_STATUS');